import { ReauthenticatableClient } from "@payleo/auth/clients";
import { JURL } from "../utils.js";
export class BillingContext extends ReauthenticatableClient {
    constructor(auth, baseUrl) {
        super(auth);
        this.url = new JURL(baseUrl).joinPath("/billing");
    }
}
